<app-notification [errorMsg]="errorMsg"></app-notification>
<form [formGroup]="userForm">

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="firstNameId" class="form-label">First Name</label>
            <input class="form-control" type="text" id="firstNameId"  formControlName="firstName" disabled>
            @if (submitted && firstName && firstName.invalid) {
              <span style="color:var(--al-danger)">First Name is required</span>
            }
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="middleNameId" class="form-label">Middle Name</label>
            <input class="form-control" type="text"  formControlName="middleName" id="middleNameId" readonly >
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="lastNameId" class="form-label">Last Name</label>
            <input class="form-control" type="text"  id="lastNameId"  formControlName="lastName" disabled>
            @if (submitted && lastName && lastName.invalid) {
              <span style="color:var(--al-danger)">Last Name is required</span>
            }
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-1">
            <label for="prefixId" class="form-label">Prefix</label>
            <input class="form-control" type="text"  formControlName="prefix" id="prefixId" disabled>
          </div>
        </div>
        <!-- <div class="col-xl-4">
        <div class="mb-1">
          <label for="cityID" class="form-label">City</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text"  formControlName="city" id="cityID" >
          <span style="color:var(--al-danger)" *ngIf="submitted && city && city.invalid">City is required</span>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label class="form-label">State</label><span style="color:var(--al-danger);">*</span>

          <select class="form-select"  formControlName="stateCode">
            <option value="" selected>Select</option>
            <option *ngFor="let value of states" [ngValue]="value.abbreviation" [selected]="value.name == userForm.value.stateName">{{value.name}}</option>
          </select>
          <span style="color:var(--al-danger)" *ngIf="submitted && stateCode && stateCode.invalid">State is required</span>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="zipCode" class="form-label">Zip Code</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text" formControlName="zip" id="zipCode">
          <span style="color:var(--al-danger)" *ngIf="submitted && zip && zip.invalid">Zip Code is required</span>
        </div>
      </div> -->

      <div class="col-xl-4">
        <div class="mb-1">
          <label for="example-text-input" class="form-label">Company Name</label>
          <input class="form-control" type="text"  formControlName="companyName" id="companyId" appSpellCheck>
          <!-- <span style="color:var(--al-danger)" *ngIf="submitted && companyName && companyName.invalid">Address is required</span> -->
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="example-text-input" class="form-label">Address</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text"  formControlName="address" id="addressId" appSpellCheck>
          @if (submitted && address && address.invalid) {
            <span style="color:var(--al-danger)">Address is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="example-text-input" class="form-label">City</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text"  formControlName="city" appSpellCheck>
          @if (submitted && city && city.invalid) {
            <span style="color:var(--al-danger)">City is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label class="form-label">State</label><span style="color:var(--al-danger);">*</span>
          <select class="form-select"  formControlName="state">
            <option [value]="" selected disabled>Select</option>
            @for (value of stateCodeMapList; track value) {
              <option [ngValue]="value.value"
                [selected]="value.label == userForm.value.stateName">{{value.label}}
              </option>
            }
          </select>
          @if (submitted && state && state.invalid) {
            <span style="color:var(--al-danger)">State is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="example-text-input" class="form-label">Zipcode</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text"  formControlName="zip"  >
          @if (submitted && zip && zip.invalid) {
            <span style="color:var(--al-danger)">Zipcode is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="mainEmailId" class="form-label">Main Email</label>
          <input class="form-control" type="text"  formControlName="mainEmail" id="mainEmailId" disabled>
          @if (submitted && mainEmail && mainEmail.errors?.required) {
            <span style="color:var(--al-danger)">Main Email is required</span>
          }
          @if (submitted && mainEmail && mainEmail.errors?.email) {
            <span style="color:var(--al-danger)">Main Email is invalid</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="otherEmail" class="form-label">Personal Email</label>
          <input class="form-control" type="text"  formControlName="otherEmail" id="otherEmail">
          <!-- <span style="color:var(--al-danger)" *ngIf="submitted && otherEmail && otherEmail.errors?.required">Main Email is required</span> -->
          @if (submitted && userForm.get('otherEmail')?.errors?.email) {
            <span style="color:var(--al-danger)">Personal Email is invalid</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="phoneNumberId" class="form-label">Phone Number</label><span style="color:var(--al-danger);">*</span>
          <input class="form-control" type="text" formControlName="phoneNumber" id="phoneNumberId" (keyup)="formatPhoneNumber($event.target.value,false)" maxlength="14">
          @if (submitted && phoneNumber && phoneNumber.errors?.required) {
            <span style="color:var(--al-danger)">Phone Number is required  </span>
          }
          @if (submitted && phoneNumber && !phNoValid) {
            <span style="color:var(--al-danger)">Enter valid Phone Number</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="extnNoId" class="form-label">Extension</label>
          <input class="form-control" type="text" formControlName="extnNo" id="extnNoId" >
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="mobileNumberId" class="form-label">Mobile Number</label>
          <input class="form-control" type="text" formControlName="mobileNumber" id="mobileNumberId" (keyup)="formatPhoneNumber($event.target.value,true)" maxlength="14">
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="faxNumberId" class="form-label">Fax Number</label>
          <input class="form-control" type="number" formControlName="faxNumber" id="faxNumberId">
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label for="finCenId" class="form-label">FinCen Id</label>
          <input class="form-control" type="text" formControlName="finCenId" id="finCenId" >
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label class="form-label">TimeZone</label><span style="color:var(--al-danger);">*</span>

          <select class="form-select"  formControlName="timeZoneCode">
            <option  value="" selected>Select</option>
            @for (value of timeZones; track value) {
              <option [ngValue]="value" [selected]="value == userForm.value.timeZoneCode">{{value}}</option>
            }
          </select>
          @if (submitted && timeZoneCode && timeZoneCode.invalid) {
            <span style="color:var(--al-danger)">TimeZone is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label class="form-label">Role</label><span style="color:var(--al-danger);">*</span>

          @if (userForm.get('roleCodes')?.disabled) {
            <app-static-multi-value [values]="getStaticLabels('roleCodes', roles, 'value', 'key')"></app-static-multi-value>
          } @else {
            <p-multiSelect [maxSelectedLabels]="10000"  defaultLabel="Select roles" appendTo="body" formControlName="roleCodes" [options]="roles" optionLabel="key" optionValue="value"></p-multiSelect>
          }
          @if (submitted && roleCodes && roleCodes.invalid) {
            <span style="color:var(--al-danger)">Role is required</span>
          }
        </div>
      </div>
      <div class="col-xl-4">
        <div class="mb-1">
          <label class="form-label">Type</label>
          <select class="form-select" formControlName="userTypeCode"><span style="color:var(--al-danger);">*</span>
          <option value="" selected>Select</option>
          @for (value of types; track value) {
            <option [ngValue]="value" [selected]="value == userForm.value.userTypeCode">{{value}}</option>
          }
        </select>
        @if (submitted && userTypeCode && userTypeCode.invalid) {
          <span style="color:var(--al-danger)">Type is required</span>
        }
      </div>
    </div>
    <div class="col-xl-4">
      <div class="mb-1">
        <label class="form-label">TK Practice Area(s)</label><span style="color:var(--al-danger);">*</span>
        @if (userForm.get('tkPracticeArea')?.disabled) {
          <app-static-multi-value [values]="getStaticLabels('tkPracticeArea', tkAreas, 'description', 'description')"></app-static-multi-value>
        } @else {
          <p-multiSelect [maxSelectedLabels]="10000"  appendTo="body" defaultLabel="Select Practice Area" formControlName="tkPracticeArea" [options]="tkAreas" optionLabel="description" optionValue="description"></p-multiSelect>
        }
        @if (submitted && tkPracticeArea && tkPracticeArea.invalid) {
          <span style="color:var(--al-danger)">Practice Area is required</span>
        }
      </div>
    </div>
    <div class="col-xl-4">
      <div class="mb-1">
        <label class="form-label">PM Practice Manager</label>
        <select class="form-select" formControlName="pmPracticeArea">
          <option value="" selected>Select</option>
          @for (value of tkAreas; track value) {
            <option [ngValue]="value.description" [selected]="value.description == userForm.value.pmPracticeArea">{{value.description}}</option>
          }
        </select>
      </div>
    </div>
    <div class="col-xl-4">
      <div class="mb-1">
        <label for="tkAutoApproval" class="form-label">TK Auto Approver Time</label><span style="color:var(--al-danger);">*</span>
        <select class="form-select" formControlName="tkAutoApproval" [disabled]="!isAdmin">
          <option [value]="" selected>Select</option>
          <option value="Yes" selected>Yes</option>
          <option value="No" selected>No</option>

        </select>
        @if (submitted && tkAutoApproval && tkAutoApproval.invalid) {
          <span style="color:var(--al-danger)"
            >Enforced
          Estimated Time is required</span>
        }
      </div>
    </div>

    <!-- <div class="col-xl-4">
    <div class="mb-1">
      <label class="form-label">Approver</label>
      <select class="form-select" formControlName="approver">
        <option value="" selected>Select</option>
        <option *ngFor="let value of lpcUsersList" [ngValue]="value.id" [selected]="value.id == userForm.value.approver">{{value.mainEmail}}</option>
      </select>
    </div>
  </div> -->

</div>

</div>
</div>

@if (!viewOnly) {
  <div class="row">
    <div class="col-xl-12">
      <div class="button-items" style="float: right;">
        @if (newUser) {
          <a class="btn btn-primary"  (click)="saveUser()"> Save @if (isLoading) {
            <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
          }</a>
        }
        @if (!newUser) {
          <a class="btn btn-primary"  (click)="editUser()"> Update @if (isLoading) {
            <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
          }</a>
        }
        <a class="btn btn-secondary" (click)="closeDialog()"> Cancel </a>
      </div>
    </div>
  </div>
}

</form>
